import { styled } from "goober";
import { spin } from "./motion";

const SpinnerRing = styled("span")`
  display: inline-block;
  border-radius: 50%;
  border: 1.5px solid var(--border-alpha);
  border-top-color: var(--text-secondary);
  animation: ${spin} 700ms linear infinite;
`;

export function Spinner({ size = 16 }: { size?: number }) {
  return <SpinnerRing style={{ width: size, height: size }} />;
}
